// extracted by mini-css-extract-plugin
export default {"container":"BrandCarousel_container__h+D4+","slide":"BrandCarousel_slide__nKD8X"};